import React, { useEffect, useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, MenuItem, Button
} from '@mui/material';
import { Assignment } from '../services/assignmentService';

interface EditMassAssignmentDialogProps {
  open: boolean;
  assignmentIds: number[] | null;
  onClose: () => void;
  onSave: (assignmentIds: number[], fields: Partial<Assignment>) => Promise<void>;
}

const statusOptions = ['assigned', 'in-progress', 'completed'];

const EditMassAssignmentDialog: React.FC<EditMassAssignmentDialogProps> = ({
  open,
  assignmentIds,
  onClose,
  onSave
}) => {
  const [status, setStatus] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  // Reset fields when dialog opens
  useEffect(() => {
    setStatus('');
    setStartDate('');
    setEndDate('');
  }, [open]);

  const handleSave = () => {
    if (!assignmentIds || assignmentIds.length === 0) return;
    const fields: Partial<Assignment> = {};
    if (status) fields.status = status;
    if (startDate) fields.start_date = new Date(startDate).toISOString();
    if (endDate) fields.end_date = new Date(endDate).toISOString();
    onSave(assignmentIds, fields); // Call with ids and fields!
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Edit Assignments</DialogTitle>
      <DialogContent>
        <TextField
          margin="dense"
          select
          label="Status"
          value={status}
          onChange={e => setStatus(e.target.value)}
          fullWidth
        >
          <MenuItem value="">-- No Change --</MenuItem>
          {statusOptions.map(opt => (
            <MenuItem key={opt} value={opt}>{opt}</MenuItem>
          ))}
        </TextField>
        <TextField
          margin="dense"
          label="Start Date"
          type="datetime-local"
          value={startDate}
          onChange={e => setStartDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          fullWidth
        />
        <TextField
          margin="dense"
          label="Due Date"
          type="datetime-local"
          value={endDate}
          onChange={e => setEndDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          fullWidth
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleSave}
          variant="contained"
          disabled={!status && !startDate && !endDate}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditMassAssignmentDialog;